import { SET_PROMO } from "../../actions";
const initialState = {
  promo: [],
};

const promo = (state = initialState, action) => {
  switch (action.type) {
    case SET_PROMO:
      return {
        ...state,
        [action.inputType]: action.inputValue,
      };
    default:
      return state;
  }
};

export default promo;
